// @NOTE: assumes jQuery is included by WP
const $ = jQuery

import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, Keyboard, A11y } from 'swiper/modules';

class modules {
  constructor () {
    this.$playButton               = $('.js-video-play-button')
    this.$closeModalButton         = $('.js-video-close-modal')
    this.$player                   = null
    this.$body                     = $('body')
    this.$iframe                   = $('body .modal iframe')
    this.modalIsOpen               = false
    this.openVideoModal()
    this.closeVideoModal()
    this.testimonialSlider()
    this.practiceAreaSlider ()
    this.newsletterForm()
    this.carouselSlider()
    this.$accordionItems           = $('.accordion-items');
    this.accordion()
    this.wpCaption                 = $('.wp-caption')
    this.wpCaptionStyle()
    this.learnMoreScroll()
    this.disableNativeValidation()
  }

  disableNativeValidation() {
    const targetNode = document.body;

    const observer = new MutationObserver(() => {
      const form = document.querySelector('#ctct_form_1');
      if (form) {
        observer.disconnect();

        form.setAttribute('novalidate', 'novalidate');

        form.querySelectorAll('input, textarea, select').forEach(input => {
          input.setCustomValidity('');
          input.addEventListener('invalid', e => e.preventDefault());
        });

        const inputObserver = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
              if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA' || node.tagName === 'SELECT') {
                node.setCustomValidity('');
                node.addEventListener('invalid', e => e.preventDefault());
              }
            });
          });
        });

        inputObserver.observe(form, { childList: true, subtree: true });
      }
    });

  observer.observe(targetNode, { childList: true, subtree: true });
  }

  learnMoreScroll () {
    $('.transparent_background_white_text_underlined_down_arrow').on('click', function (e) {
      e.preventDefault()

      const $section = $(this).closest('section').next('section')

      if (!$section.length) return

      const navOffset = 170
      const targetPosition = $section.offset().top - navOffset

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    })
  }

  closeVideoModal () {
    this.$closeModalButton.on('click', (event) => {
      event.preventDefault();
      $(event.currentTarget).parents('.modal').removeClass('show-modal')
      this.$body.removeClass('overflow-hidden')
      this.stopIframeVideo()
      this.modalIsOpen = false
    })

    this.$body.on('click', (event) => {
      if (!this.modalIsOpen) {
        return
      }

      if (!$(event.target).closest('.modal-inner, .play-button,.team-co-founders-lists').length) {
        $('body').find('.modal').removeClass('show-modal')
        $('body').removeClass('overflow-hidden')
        //$('#iframe-video-holder iframe').remove();
        this.stopIframeVideo()
      }
    })

    $(document).on('keydown', (event) => {
      if ((event.key === 'Escape' || event.keyCode === 27) && this.modalIsOpen) {
        $('body').find('.modal').removeClass('show-modal')
        $('body').removeClass('overflow-hidden')
        this.stopIframeVideo()
        this.modalIsOpen = false
      }
    })
  }

  openVideoModal () {
    this.$playButton.on('click', (event) => {

      this.lastFocusedButton = event.currentTarget

      const $modal = $(event.currentTarget)
        .closest('.video-outer-wrap')
        .next('.modal')

      if (!$modal.length) return

      $modal.addClass('show-modal')
      this.$body.addClass('overflow-hidden')
      this.modalIsOpen = true

      $modal.attr('aria-hidden', 'false')

      requestAnimationFrame(() => {
        const $closeBtn = $modal.find('.js-video-close-modal')

        if ($closeBtn.length) {
          $closeBtn.trigger('focus')
        }
      })
    })
  }

  stopIframeVideo() {
    this.$iframe.each(function(){
      ($(this).attr('src', $(this).attr('src')))
    });
  }

  testimonialSlider () {
    const swiper = new Swiper('.testimonial-slider-wrapper', {
      modules: [Pagination, Navigation, Keyboard, A11y],
      loop: true,
      slidesPerView:1,
      pagination: {
        el: '.testimonial-slider-wrapper .swiper-pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      scrollbar: {
        el: '.swiper-scrollbar',
      },

      a11y: {
        enabled: true,
      },
    });
  }

  practiceAreaSlider() {
    const swiper = new Swiper('.practice-area-slider-wrapper', {
      modules: [Pagination, Navigation, Keyboard, A11y],
      loop: true,
      spaceBetween: 40,
      autoHeight: true,

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<button class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
        },
      },
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      a11y: {
        enabled: true,
      },

      breakpoints: {
        0: {
          direction: 'horizontal',
        },
        1023: {
          direction: 'vertical',
        },
      },
    });

    document.querySelectorAll('li[data-slide-index]').forEach(item => {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        const index = parseInt(this.getAttribute('data-slide-index'));
        swiper.slideToLoop(index);

        if (window.innerWidth < 1024) {
          setTimeout(() => {
            const activeSlide = document.querySelector('.swiper-slide-active');
            if (activeSlide) {
              const yOffset = -50;
              const y = activeSlide.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
          }, 300);
        }
      });
    });

    swiper.on('slideChange', function () {
      const realIndex = swiper.realIndex;
      document.querySelectorAll('li[data-slide-index]').forEach(li => {
        li.classList.toggle('active', parseInt(li.getAttribute('data-slide-index')) === realIndex);
      });
    });
  }

  carouselSlider() {
    const swiper = new Swiper('.carousel-slider', {
      modules: [Autoplay, Keyboard, A11y],
      loop: true,
      spaceBetween: 5,
      speed: 1000,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        reverseDirection: true,
      },

      a11y: {
        enabled: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 2.5,
          centeredSlides: true,
        },
        768: {
          slidesPerView: 2.5,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 4,
          centeredSlides: false,
        },
      },
    });
  }

  newsletterForm () {
    const interval = setInterval(() => {
      const $newsletterForm = $('.ctct-form-custom');
      const $newsletterFormWrapper = $('.ctct-inline-form');
      const $inputLabel = $('.ctct-form-label');
      const $input = $('.ctct-form-element');

      $newsletterFormWrapper.addClass('newsletter-form-wrapper');
      $newsletterForm.addClass('newsletter-form');
      $input.attr('placeholder', 'Your Email');
      $input.addClass('newsletterInput');
      $inputLabel.addClass('sr-only');

    }, 100);
  }

  accordion() {
    this.$accordionItems.removeClass('active-accordion');

    this.$accordionItems.find('.accordion-btn')
      .attr({
        tabindex: '0',
        role: 'button',
        'aria-expanded': 'false'
      })
      .on('click keydown', function (e) {
        const $item = $(this).closest('.accordion-items');
        const isActive = $item.hasClass('active-accordion');

        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          $item.toggleClass('active-accordion', !isActive);
          $(this).attr('aria-expanded', String(!isActive));

          $item.find('.accordion-content').prop('hidden', isActive);

        } else if (e.type === 'keydown' && e.key === 'Escape') {
          if (isActive) {
            e.preventDefault();

            $item.removeClass('active-accordion');
            $(this).attr('aria-expanded', 'false');
            $item.find('.accordion-content').prop('hidden', true);
          }
        }
      });
  }

  wpCaptionStyle() {
    this.wpCaption.css('width', '100%');
  }

}

export default modules